import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { searchData } from '../assets/js/functions';

export const useUserData = () => {
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        try {
          const data = await searchData(process.env.REACT_APP_BD_USUARIOS, user.uid);
          setUserData(data);
        } catch (error) {
          console.error('Error obteniendo datos del usuario:', error);
        }
      }
      setLoading(false);
    };

    fetchUserData();
  }, [user]);

  return { userData, loading, isAuthenticated: !!user };
};
